import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseGroupType } from '../../../../../../AngularJS/Models/group-type.model';
import { GroupSelectorDTO } from '../../../../../../AngularJS/Reusables/group-selector.models';
import { GroupSelectorComponent } from '../../../../../reusables/group-selector/group-selector.component';
import { PointStoreProductOrderService } from '../../../agent-side/services/point-store-product-order.service';

@Component({
  selector: 'cv-point-store-product-group-selector',
  templateUrl: './point-store-product-group-selector.component.html',
  styleUrls: ['./point-store-product-group-selector.component.scss']
})
export class PointStoreProductGroupSelectorComponent implements OnInit {

  @ViewChild("groupSelectorDTOComp") groupSelectorDTOComp: GroupSelectorComponent;
  pspos: any = null;
  groupType: number = 0;
  stateKey: string = 'PointStoreAdmin';

  empSelectorDTO: GroupSelectorDTO = {
    ApplicationID: 0,
    PageName: "PointStoreAdmin",
    SelectedGroupLevel: 1,
    SelectedGroupType: BaseGroupType.Employee,
    SelectedMinLevel: 1,
    SelectedMaxLevel: 5,
    _SelectedGroup1IDList: [0],
    _SelectedGroup2IDList: [0],
    _SelectedGroup3IDList: [0],
    _SelectedGroup4IDList: [0],
    _SelectedGroup5IDList: [0],
    ModuleRender: false,
    ShiftRender: false,
    AllSelected: true,
    toggleGroupData: false
  };

  constructor(
    private pointStoreProductOrderService: PointStoreProductOrderService
  ) {
    this.pspos = this.pointStoreProductOrderService.pointStoreProductOrderObj;
  }

  ngOnInit() {
    this.loadEmpGroupState();
  }  

  /**
   * 
   * @param dto 
   */
  async onSelectedLevelChanged(dto: any) {
    this.pspos.pointStoreProductAdminOrderFilter.gLvl = this.groupSelectorDTOComp.lastLevelChanged;

    for(let i = 1; i <= this.pspos.pointStoreProductAdminOrderFilter.empGroup.length -1; i++){
      if (this.pspos.pointStoreProductAdminOrderFilter.gLvl > i) {
        this.pspos.pointStoreProductAdminOrderFilter.empGroup[i][0] = "-1"; //Colapsing Selector
      }
      await this.saveEmpGroupState(this.pspos.pointStoreProductAdminOrderFilter.gLvl, "e", this.pspos.pointStoreProductAdminOrderFilter.empGroup[i], this.pspos.pointStoreProductAdminOrderFilter.empGroup);
    }
    await this.pointStoreProductOrderService.LoadPointStoreProductAdminOrders();
    this.pspos.pointStoreProductAdminOrderFilter.groupSelectorChanged = true;
  }

  /**
   * 
   * @param dto 
   */
  async onEmpGroupsChanged(dto: GroupSelectorDTO) {
    let selectedLevel: number = this.groupSelectorDTOComp.lastLevelChanged;
    this.pspos.pointStoreProductAdminOrderFilter.gLvl = selectedLevel;
    this.pspos.pointStoreProductAdminOrderFilter.gIDs = this.getIdsFromSelectedLevel(selectedLevel, dto);
    this.pspos.pointStoreProductAdminOrderFilter.gType = dto.SelectedGroupType;

    if (this.pspos.pointStoreProductAdminOrderFilter.empGroup == undefined) {
      this.pspos.pointStoreProductAdminOrderFilter.empGroup = [];
    }
    if (this.pspos.pointStoreProductAdminOrderFilter.empGroup.length) {
      for (let index = 1; index < this.pspos.pointStoreProductAdminOrderFilter.empGroup.length; index++) {
        if (this.pspos.pointStoreProductAdminOrderFilter.empGroup[index] == null) {
          this.pspos.pointStoreProductAdminOrderFilter.empGroup[index] = ["0"];
        }
      }
    }
    let filterChanged = (this.pspos.pointStoreProductAdminOrderFilter.empGroup[selectedLevel].length == this.pspos.pointStoreProductAdminOrderFilter.gIDs.length)
      && this.pspos.pointStoreProductAdminOrderFilter.empGroup[selectedLevel].every((element, index) => element === this.pspos.pointStoreProductAdminOrderFilter.gIDs[index].toString());

    if (!filterChanged) {
      this.pspos.pointStoreProductAdminOrderFilter.empGroup[selectedLevel] = this.pspos.pointStoreProductAdminOrderFilter.gIDs.map((group: number)=>{return group.toString()});
      for (let i = selectedLevel; i > 1; i--) {
        if (this.pspos.pointStoreProductAdminOrderFilter.empGroup[i - 1][0] != -1) {
          this.pspos.pointStoreProductAdminOrderFilter.empGroup[i - 1] = [];
          this.pspos.pointStoreProductAdminOrderFilter.empGroup[i - 1][0] = "0";
        }
      }
    }
    this.pspos.isloadingExternalFilter = true;
    await this.saveEmpGroupState(this.groupSelectorDTOComp.lastLevelChanged, "e", this.pspos.pointStoreProductAdminOrderFilter.gIDs.map((group: number)=>{return group.toString()}), this.pspos.pointStoreProductAdminOrderFilter.empGroup);
    await this.pointStoreProductOrderService.LoadPointStoreProductAdminOrders()
    this.pspos.pointStoreProductAdminOrderFilter.groupSelectorChanged = true;
  }

  /**
   * 
   * @param selectedLevel 
   * @param dto
   * @returns 
   */
  getIdsFromSelectedLevel(selectedLevel: number, dto: GroupSelectorDTO): number[] {
    let selectedIds: number[] = [];
    switch (selectedLevel) {
      case 1:
        selectedIds = dto._SelectedGroup1IDList;
        break;
      case 2:
        selectedIds = dto._SelectedGroup2IDList;
        break;
      case 3:
        selectedIds = dto._SelectedGroup3IDList;
            break;
      case 4:
        selectedIds = dto._SelectedGroup4IDList;
            break;
      case 5:
        selectedIds = dto._SelectedGroup5IDList;
            break;
      default:
        break;
    }
    return selectedIds;
  }

  //Load the state of the group selector
  loadEmpGroupState(){
    //Create object
    this.pspos.pointStoreProductAdminOrderFilter.empGroup = [];

    for (let i = 1; i <= 5; i++) {
      //Initializing object 
      this.pspos.pointStoreProductAdminOrderFilter.empGroup[i] = ["0"];
    }

    this.pointStoreProductOrderService.loadMarketplaceEmpgroupState().then((result)=>{
      this.groupType = result.m_Item3;
      
      this.empSelectorDTO.SelectedGroupLevel = result.m_Item1;
      this.pspos.pointStoreProductAdminOrderFilter.gLvl = result.m_Item1;
      this.pspos.pointStoreProductAdminOrderFilter.gIDs = result.m_Item2;
      this.pspos.pointStoreProductAdminOrderFilter.empGroup[result.m_Item1] = result.m_Item2;
      var allGroups = result.m_Item4;
      this.empSelectorDTO.SelectedGroupLevel = result.m_Item1;
      this.pspos.pointStoreProductAdminOrderFilter.gLvl = result.m_Item1;

      if (result.m_Item4) {
        for (let i = 1; i < allGroups.length; i++) {
          if ((allGroups[i]) && (i <= this.pspos.pointStoreProductAdminOrderFilter.empGroup.length)) {
            this.pspos.pointStoreProductAdminOrderFilter.empGroup[i] = allGroups[i];
          }
          this.empSelectorDTO["_SelectedGroup" + i + "IDList"] = allGroups[i].map((group)=>{return parseInt(group)});
        }
      }
    });
  }

  //Load the state of the group selector
  async saveEmpGroupState(groupLevel, groupType, idsArray, empGroup){
    await this.pointStoreProductOrderService.saveMarketplaceEmpgroupState(groupLevel, groupType, idsArray, empGroup);
  }
}